//import { J3PanelBase } from './J3PanelBase';

export class J3LoaderPanel {
    container:HTMLElement = null;
    timerID;

    constructor(debugLvl = 0, enable = true, containerID: string = 'loader', public limitTime:number = 10) {
        
        if (enable) {
            this.container = document.querySelector('#' + containerID) as HTMLElement;
            if (this.container) {
                //DOM要素を作成
                //<!-- loading -->
                //<div id="loader">  //これがcontainer
                //  <p>
                //      <span>N</span><span>o</span><span>w</span>
                //      <span>L</span><span>o</span><span>a</span><span>d</span><span>i</span><span>n</span><span>g</span>
                //      <img src="https://www.tanabotanical.com/img/bee.png" alt="loading" />
                //  </p>
                //</div>
                //<!-- /loading -->
                const p = document.createElement('p');
                this.container.appendChild(p);
                // 'Now Loading'のSpan要素を作成
                this.AddSpanElement(p, 'N');
                this.AddSpanElement(p, 'o');
                this.AddSpanElement(p, 'w');
                this.AddSpanElement(p, 'L');
                this.AddSpanElement(p, 'o');
                this.AddSpanElement(p, 'a');
                this.AddSpanElement(p, 'd');
                this.AddSpanElement(p, 'i');
                this.AddSpanElement(p, 'n');
                this.AddSpanElement(p, 'g');
                //画像
                const img = document.createElement('img');
                img.src = 'https://www.tanabotanical.com/img/bee.png';
                img.alt = 'loading';
                p.appendChild(img);

                //表示
                this.Show();
                console.log('J3LoaderPanel', this.limitTime);

            }
        }else{
            this.container = document.querySelector('#' + containerID) as HTMLElement;
            if (this.container) {
                this.container.style.display = 'none';
            }
        }
    }

    AddSpanElement(parent:HTMLElement, char:string = ''){
        const span:HTMLElement = document.createElement('span');
        span.textContent = char;
        parent.appendChild(span);
    }

    Show(){
        this.timerID = setTimeout(()=>this.Hide(), this.limitTime*1000);
        this.container.style.display = 'block';
    }
    Hide(){
        clearTimeout(this.timerID);
        this.container.style.display = 'none';
    }
}